// https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
export function getMobileOS(): 'Android' | 'iOS' | null {
  const userAgent = navigator.userAgent || navigator.vendor

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS'
  }

  return null
}
